import { render, staticRenderFns } from "./TokenExpirePage.vue?vue&type=template&id=0feacc5d&scoped=true&"
import script from "./TokenExpirePage.vue?vue&type=script&lang=js&"
export * from "./TokenExpirePage.vue?vue&type=script&lang=js&"
import style0 from "./TokenExpirePage.vue?vue&type=style&index=0&id=0feacc5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feacc5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0feacc5d', component.options)
    } else {
      api.reload('0feacc5d', component.options)
    }
    module.hot.accept("./TokenExpirePage.vue?vue&type=template&id=0feacc5d&scoped=true&", function () {
      api.rerender('0feacc5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TokenExpirePage.vue"
export default component.exports